import type { CloudGraphRemoteLinkEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI: CloudGraphRemoteLinkEntityAti[] = [
	'ati:cloud:graph:remote-link',
];
